var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "shape1",
    d: "M128 424C57 424 0 350 0 350s57-74 128-74 128 74 128 74-57 74-128 74z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "shape2",
    d: "M218 207c50 50 38 143 38 143s-93 12-143-38-38-143-38-143 93-11 143 38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "shape3",
    d: "M330 222c0 71-74 128-74 128s-74-57-74-128c0-70 74-128 74-128s74 58 74 128z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "shape4",
    d: "M399 312c-50 50-143 38-143 38s-12-93 38-143c50-49 143-38 143-38s12 93-38 143z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "shape5",
    d: "M384 424c-71 0-128-74-128-74s57-74 128-74 128 74 128 74-57 74-128 74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d07641cf5aea1f7a0ac7c6e126eca071.svg";
export { ForwardRef as ReactComponent };